import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { CommonService } from "src/app/services/common.service";

@Component({
  selector: "app-reset-password",
  templateUrl: "./reset-password.component.html",
  styleUrls: ["./reset-password.component.scss"],
})
export class ResetPasswordComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private _common: CommonService
  ) {}

  passForm: FormGroup;
  userId: string;
  token: string;
  alertClass: string;
  alertText: string;
  submitted: boolean = false;
  apiResponse: boolean = false;

  ngOnInit(): void {
    this.userId = this.route.snapshot.paramMap.get("id");
    this.token = this.route.snapshot.paramMap.get("token");

    this.passForm = this.fb.group(
      {
        password: ["", [Validators.required, Validators.minLength(6)]],
        confirmPassword: ["", [Validators.required]],
      },
      { validator: this.passwordMatchValidator }
    );
  }

  onSubmit(): void {
    this.submitted = true;
    if (this.passForm.valid) {
      const data = {
        password: this.passForm.value.password,
        user_id: this.userId,
        token: this.token,
      };
      this._common.post(`v1/resetPassword`, data).subscribe((resp: any) => {
        if (resp.success) {
          this.alertClass = "success";
          this.submitted = false;
          this.passForm.reset();
        } else {
          this.alertClass = "error";
        }
        this.alertText = resp.message;
        this.apiResponse = true;
      });
    }
  }

  passwordMatchValidator(formGroup: FormGroup): void {
    const password = formGroup.get("password").value;
    const confirmPassword = formGroup.get("confirmPassword").value;
    if (password !== confirmPassword) {
      formGroup.get("confirmPassword").setErrors({ mismatch: true });
    } else {
      formGroup.get("confirmPassword").setErrors(null);
    }
  }
}
